import React from "react";
import styled from "styled-components";
import { translate } from "../../../base/i18n";
import { MEDIA_TYPE } from "../../../base/media";
import { connect } from "../../../base/redux";
import { muteAllParticipants } from "../../../video-menu";
import { DEVICE_PERMISSION_MODAL_ID } from "../../constants";
import AbstractPopup from "../AbstractPopup";

const DeviceStyled = styled.ul`
    display: flex;
    text-align: center;

    dl {cursor: pointer;}
    dt {
        margin: 10px 0;
        width: 23px;
        height: 26px;
    }
`

class DevicePermission extends AbstractPopup {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this._setModalID(DEVICE_PERMISSION_MODAL_ID);
    }

    audioMuted(isMuted) {
        this.props.dispatch(muteAllParticipants([], MEDIA_TYPE.AUDIO, isMuted));
    }
    videoMuted(isMuted) {
        this.props.dispatch(muteAllParticipants([], MEDIA_TYPE.VIDEO, isMuted));
    }

    _renderContent() {
        return (
            <DeviceStyled style={{display:"flex"}}>
                { APP.function.allPermission.micOn && <li>
                    <dl onClick={() => this.audioMuted(false)}>
                        <dd> {this.props.t("options.onMic")} </dd>
                        <dt className={`icoImg speakerSwitch`} style={{backgroundPosition: "-170px -146px"}}></dt>
                    </dl>
                </li> }
                { APP.function.allPermission.micOff && <li>
                    <dl onClick={() => this.audioMuted(true)}>
                        <dd> {this.props.t("options.offMic")} </dd>
                        <dt className={`icoImg speakerSwitch`} style={{backgroundPosition: "-136px -146px"}}></dt>
                    </dl>
                </li> }
                { APP.function.allPermission.videoOn && <li>
                    <dl onClick={() => this.videoMuted(false)}>
                        <dd> {this.props.t("options.onVideo")} </dd>
                        <dt className={`icoImg speakerSwitch`} style={{backgroundPosition: "-170px -179px"}}></dt>
                    </dl>
                </li> }
                { APP.function.allPermission.videoOff && <li>
                    <dl onClick={() => this.videoMuted(true)}>
                        <dd> {this.props.t("options.offVideo")} </dd>
                        <dt className={`icoImg speakerSwitch`} style={{backgroundPosition: "-136px -179px"}}></dt>
                    </dl>
                </li> }
            </DeviceStyled>
        )
    }

    render() {
        const content = this._renderContent();

        return (
            <div className="option_pop center" style={{width: "450px"}}>
                { this._renderPopupHeader(this.props.t, 'options.setFullPermission') }
                { this._renderPopupBody(content) }
            </div>
        )
    }
}


export default translate(connect()(DevicePermission));